<template>
  <div>
    <button class="btn btn-primary btn-sm"
        data-toggle="tooltip" 
        data-placement="top" 
        title="New"
        @click="fnShowModal()">New
    </button>

    <b-modal ref="modal" hide-footer title="Residential status - new">
        <div class="d-block">
        <form v-on:submit.prevent="createNew">

            <div class="form-group">
                <label for="name">Status</label>
                <input type="text" 
                class="form-control" 
                id="name" 
                placeholder="Status"
                v-model="name">
                <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
            </div>
        <hr>
        <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button type="submit" class="btn btn-primary btn-sm">Save</button>
        </div>
        </form>
        </div>
    </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as residentialStatusService from '../../services/residentialStatus.service';
    export default {
        name:"ModalResidentialStatusNew",
        components: {
            
        },
        data(){
            return{
                errors:{},
                name:''
            }
        },
        methods:{
            ...mapActions(['fetchResidentialStatusAll']),
            fnShowModal(){
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            createNew:async function(){
                let formData = new FormData();
                formData.append('name',this.name);
            try{
                const response = await residentialStatusService.add(formData);
                this.hideModal();
                this.fetchResidentialStatusAll();

                messageService.fnSweetAlertSuccessToast('Residential status - new', 'added successfully');

                this.name = '';

                }catch(error){
                    switch (error.response.status){
                    case 422:
                        this.errors = error.response.data.errors;
                        break;

                    case 500:
                        messageService.fnSweetAlertErrorToast('Residential status - new', error.response.data.message);
                        break;

                    default:
                            messageService.fnSweetAlertErrorToast('Residential status - new', 'Something wrong');
                        break;
                    }
                }
            },
        }
    }
</script>